import { predefinedColors } from '../data/constants';

export default function ColorPicker({ value, onChange, label }) {
  const isCustomSelected = value && !predefinedColors.includes(value);

  return (
    <div className="space-y-3">
      <h3 className="text-xl font-semibold mb-4">Color Theme</h3>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
        {label}
      </label>

      {/* Preset colors */}
      <div className="flex flex-wrap gap-2">
        {predefinedColors.map(color => (
          <button
            key={color}
            onClick={() => onChange(color)}
            className={`flex-1 aspect-square rounded-xl border-2 transition-all duration-200 shadow-md hover:shadow-lg hover:scale-105
              ${value === color ? 'ring-4 ring-indigo-500 ring-offset-2 ring-offset-gray-50 dark:ring-offset-dark-bg scale-105 shadow-xl' : 'border-gray-300 dark:border-gray-600'}`}
            style={{ backgroundColor: color }}
            title={color}
          />
        ))}

        {/* Custom color button */}
        <button
          onClick={() => onChange(isCustomSelected ? value : '#ffffff')}
          className={`flex-1 aspect-square rounded-xl border-2 transition-all duration-200 shadow-md hover:shadow-lg hover:scale-105 bg-gradient-to-br from-red-500 via-green-500 to-blue-500
            ${isCustomSelected ? 'ring-4 ring-indigo-500 ring-offset-2 ring-offset-gray-50 dark:ring-offset-dark-bg scale-110 shadow-xl' : 'border-gray-300 dark:border-gray-600'}`}
          title="Custom color"
        />
      </div>

      {/* Custom HEX input */}
      <input
        type="text"
        maxLength={7}
        minLength={7}
        value={value || ''}
        onChange={e => onChange(e.target.value)}
        placeholder="#RRGGBB"
        className="w-32 px-3 py-2 rounded-lg bg-white dark:bg-dark-card border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-indigo-500"
      />
    </div>
  );
}

